import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { DataClass } from 'scrivito'

import { ListCreateAction } from './ListCreateAction'
import { Button } from '@/Atomic/Molecules/Button'
import { CSVModal } from '@/Atomic/Widgets/Imports/CSVModal'
import { ImportStatus } from '@/Atomic/Widgets/Imports/CSVModal/useCsvModal'
import {
  DocumentsUploadButton,
  DocumentsUploadFn,
} from '@/Components/Document/DocumentUploadTool'
import { EntityAddCanvasButton } from '@/Components/EntityAdd/EntityAddCanvas'
import { KanbanViewSwitch } from '@/Components/KanbanView/KanbanViewSwitch'
import { DataClassName } from '@/Data/const'
import { uploadDocumentsSequential } from '@/hooks/documents/uploadDocuments'

export interface OverviewHeaderActionsProps {
  dataClassName: string
  dataClass: DataClass
  kanbanViewPresent: boolean
  kanbanViewActive: boolean
  onToggleKanban: () => void
  onImportingChange?: (isImporting: boolean) => void
}

export const OverviewHeaderActions: React.FC<OverviewHeaderActionsProps> = ({
  dataClassName,
  dataClass,
  kanbanViewPresent,
  kanbanViewActive,
  onToggleKanban,
  onImportingChange,
}) => {
  const { t } = useTranslation()

  const [isCSVModalOpen, setIsCSVModalOpen] = useState(false)

  const uploadUnrelatedDocuments: DocumentsUploadFn = (files, opts) =>
    uploadDocumentsSequential(files, opts)

  const handleImportStatusChange = (status: ImportStatus) => {
    onImportingChange?.(status === 'running')
  }

  const showCsvImport =
    dataClassName === DataClassName.PERSON ||
    dataClassName === DataClassName.COMPANY

  return (
    <div className="d-flex align-items-center gap-2 justify-content-end">
      {kanbanViewPresent && (
        <KanbanViewSwitch
          onSwitchClick={onToggleKanban}
          active={kanbanViewActive}
        />
      )}
      {showCsvImport && (
        <>
          <Button
            icon="upload"
            variant="outlined"
            size="sm"
            onClick={() => setIsCSVModalOpen(true)}
          >
            {t('components.csv.importTitle')}
          </Button>
          <CSVModal
            isOpen={isCSVModalOpen}
            context="overview"
            entityName={dataClassName}
            onClose={() => setIsCSVModalOpen(false)}
            onImportStatusChange={handleImportStatusChange}
          />
        </>
      )}
      {dataClassName === DataClassName.LIST ? (
        <ListCreateAction dataClass={dataClass} />
      ) : dataClassName === DataClassName.DOCUMENT ? (
        <DocumentsUploadButton onUpload={uploadUnrelatedDocuments} />
      ) : (
        <EntityAddCanvasButton dataClass={dataClass} />
      )}
    </div>
  )
}

export default OverviewHeaderActions
